import slide1 from "../assets/Imagem_Index_Dia_das_Maes_02.webp";
import slide2 from "../assets/Imagem_Index_16.webp";
import slide11 from "../assets/Imagem_Index_Musica_Surpresa_01.webp";
import imagemHero16 from "../assets/Imagem_Index_Pais_04.webp";
import whatsappIcon from "../assets/whatsapp_icon.png";
import logoMusicaSurpresa from "../assets/Logo_Musica_Surpresa.webp";
import { useEffect, useMemo, useRef, useState } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { BRAND, WHATSAPP_NUMBER } from "../constants/brand";
import { DEFAULT_PLAN, formatPlanLabel, formatPlanPrice } from "../constants/plans";
import { formatWhatsapp, normalizeEmail, normalizeName, normalizeWhatsapp } from "../utils/formatters";
import { isValidEmail } from "../utils/validators";
import { generateOrderId, buildCustomerId } from "../utils/orderHelpers";
import { syncLeadToSheet } from "../services/googleSheets";

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState(-1);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentSongIndex, setCurrentSongIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    document.title = "Música Surpresa — Músicas Personalizadas em até 24h";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", "Crie uma música personalizada exclusiva como presente inesquecível para mães, pais, namorados e momentos especiais. Letra e melodia criadas do zero. Entrega em até 24h.");
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", "https://www.musicasurpresa.com.br");
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    whatsapp: "",
    email: "",
    plan: formatPlanLabel(DEFAULT_PLAN),
  });

  const initialPlanId = useMemo(() => "musica-surpresa", []);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "whatsapp") {
      setFormData((prev) => ({ ...prev, [name]: normalizeWhatsapp(value) }));
      return;
    }
    if (name === "name") {
      setFormData((prev) => ({ ...prev, [name]: value }));
      return;
    }
    if (name === "email") {
      setFormData((prev) => ({ ...prev, [name]: normalizeEmail(value) }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleContinueToMusicForm = async () => {
    if (!formData.name || !formData.whatsapp || !formData.email) {
      alert("Preencha nome, WhatsApp e e-mail para continuar.");
      return;
    }
    if (!isValidEmail(formData.email)) {
      alert("Digite um e-mail válido.");
      return;
    }
    if (formData.whatsapp.length < 10 || formData.whatsapp.length > 11) {
      alert("Digite um WhatsApp válido com DDD.");
      return;
    }

    const existingLead = sessionStorage.getItem("musicOrderLead");
    let existingOrderId = "";
    try {
      existingOrderId = existingLead ? JSON.parse(existingLead)?.orderId || "" : "";
    } catch (error) {
      console.error("Erro ao recuperar orderId");
    }

    const orderId = existingOrderId || generateOrderId();
    const customerId = buildCustomerId(formData.whatsapp);

    const leadPayload = {
      orderId,
      customerId,
      stage: "lead_criado",
      paymentId: "",
      paymentStatus: "",
      paymentStatusDetail: "",
      paymentMethod: "",
      planId: initialPlanId,
      planTitle: formData.plan,
      customerName: normalizeName(formData.name),
      email: formData.email,
      whatsapp: formData.whatsapp,
      recipient: "",
      relationship: "",
      occasion: "",
      description: "",
      message: "",
      moments: "",
      specialPhrase: "",
      style: "",
      voiceType: "",
      observations: "",
      amount: formData.plan.match(/R\$\s*([\d.,]+)/)?.[1] || "",
      externalReference: orderId,
    };

    sessionStorage.setItem("musicOrderLead", JSON.stringify({
      orderId: leadPayload.orderId,
      customerId: leadPayload.customerId,
      name: leadPayload.customerName,
      email: leadPayload.email,
      whatsapp: leadPayload.whatsapp,
      plan: formData.plan,
      planId: leadPayload.planId,
    }));
    sessionStorage.setItem("selectedPlan", formData.plan);

    await syncLeadToSheet(leadPayload);
    window.location.href = "/criar-musica";
  };

  const handleQuickWhatsApp = () => {
    const message = "Olá! Tenho algumas dúvidas sobre a música surpresa e gostaria de falar com vocês.";
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const heroSlides = useMemo(() => [
    {
      title: (<>Música personalizada <span style={{ color: BRAND.terracotta }}>criada do zero</span>, feita para<span style={{ color: BRAND.terracotta }}> pessoas que você ama</span></>),
      description: "Você nos conta sobre a pessoa e o que quer expressar. A gente transforma isso em uma música inédita, com letra e melodia criadas especialmente para ela ✨",
      pills: ["Qualidade\nMusical", "Entrega em\naté 24h", "Experiências\nemocionantes"],
      image: imagemHero16,
      imageAlt: "Casal ouvindo música juntos",
      cta: "💝 CRIAR MÚSICA",
    },
    {
      title: (<>
        <span className="block sm:inline">Surpreenda com</span><span className="hidden sm:inline"> </span>
        <span className="block sm:inline">músicas que <span style={{ color: BRAND.terracotta }}>falam</span></span><span className="hidden sm:inline"> </span>
        <span className="block sm:inline">sobre <span style={{ color: BRAND.terracotta }}>pessoas</span></span><span className="hidden sm:inline"> </span>
        <span className="block sm:inline" style={{ color: BRAND.terracotta }}>que você ama</span>
      </>),
      description: "Uma música inédita feita para uma pessoa específica — composta e gravada só para ela ✨",
      pills: ["Homenagens\nÚnicas", "Letra\nPersonalizada", "Entrega\nRápida"],
      image: slide2,
      imageAlt: "Mãe ouvindo música personalizada que a filha deu de presente",
      cta: "💝 CRIAR MÚSICA",
    },
    {
      title: (<>
        <span className="block sm:inline">Um presente diferente</span><span className="hidden sm:inline"> </span>
        <span className="block sm:inline">para as <span style={{ color: BRAND.terracotta }}>datas</span></span><span className="hidden sm:inline"> </span>
        <span className="block sm:inline">que <span style={{ color: BRAND.terracotta }}>mais importam</span></span>
      </>),
      description: "Para datas inesquecíveis, uma música com a história, os momentos de vocês e tudo que você quer dizer para a pessoa ✨",
      pills: ["Diferente", "Surpreendente", "Emocionante"],
      image: slide1,
      imageAlt: "Família ouvindo música personalizada para uma ocasião especial",
      cta: "💝 CRIAR MÚSICA",
    },
  ], []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [heroSlides]);

  const activeHeroSlide = heroSlides[currentSlide];

  const demoSongs = [
    { title: "Café na Cozinha", occasion: "Homenagem de filhos para a Mãe", style: "MPB Pop", audio: "/audio/Homenagem_Dia_das_Maes_Demonstracao_Musica_Surpresa.mp3" },
    { title: "É Família!", occasion: "Música da Família", style: "Pagode", audio: "/audio/Homenagem_Familia_Demonstracao_Musica_Surpresa.mp3" },
    { title: "Porto Seguro", occasion: "De Namorada para Namorado", style: "Pop Romântico", audio: "/audio/Homenagem_Namorados_Demonstracao_Musica_Surpresa.mp3" },
    { title: "Nossa Base", occasion: "Homenagem de filhos para o Pai", style: "MPB", audio: "/audio/Homenagem_Dia_dos_Pais_Demonstracao_Musica_Surpresa.mp3" },
    { title: "Meu Lugar", occasion: "Homenagem de Amigo para Amiga", style: "Pop R&B", audio: "/audio/Homenagem_Amigos_Demonstracao_Musica_Surpresa.mp3" },
  ];

  const handlePlayPause = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      if (!audioRef.current.src) {
        audioRef.current.src = demoSongs[currentSongIndex].audio;
        audioRef.current.load();
      }
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  const visibleDemoSongs = demoSongs.map((song, index) => ({ ...song, songIndex: index }));

  const handleSelectSong = (songIndex) => {
    if (!audioRef.current) return;
    if (songIndex === currentSongIndex) {
      if (!audioRef.current.src) {
        audioRef.current.src = demoSongs[songIndex].audio;
        audioRef.current.load();
      }
      handlePlayPause();
      return;
    }
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    audioRef.current.src = demoSongs[songIndex].audio;
    audioRef.current.load();
    setCurrentSongIndex(songIndex);
    setTimeout(() => {
      audioRef.current.play();
      setIsPlaying(true);
    }, 0);
  };

  const plans = [{
    name: DEFAULT_PLAN.name,
    subtitle: "Música exclusiva com letra, melodia e arranjo personalizados, criada a partir da sua história e entregue em até 24 horas.",
    priceFrom: DEFAULT_PLAN.hasDiscount ? formatPlanPrice(DEFAULT_PLAN.priceFrom) : null,
    price: formatPlanPrice(DEFAULT_PLAN.price),
    color: BRAND.terracotta,
    bg: BRAND.cream,
    border: BRAND.terracottaSoft,
    icon: "🎁",
    features: ["Letra personalizada", "Melodia exclusiva", "Arranjo profissional", "Entrega em até 24h", "Áudio com qualidade"],
    cta: "💝 CRIAR MÚSICA",
    featured: false,
  }];

  const steps = [
    { title: "Você conta tudo sobre ela ...", text: "Preencha o formulário contando quem é a pessoa, sua relação com ela, a ocasião e o que quer expressar com a música", icon: "✍️", color: BRAND.terracotta },
    { title: "Preparamos a sua música ...", text: "Nossa equipe cria letra e melodia personalizadas para a sua música", icon: "🎧", color: BRAND.terracotta },
    { title: "Produzimos, revisamos ... ", text: "Produzimos, analisamos e revisamos sua música com toda a nossa experiência", icon: "🔍", color: BRAND.terracotta },
    { title: "Sua música fica pronta!", text: "Enviamos um áudio inédito — com letra e melodia criadas só para essa pessoa — pronto para emocionar", icon: "🎁", color: BRAND.terracotta },
  ];

  const testimonials = [
    { name: "Rayane C.", city: "São Paulo - SP", context: "Encomendou uma música para o aniversário da mãe", quote: "Gente do céu, que coisa mais linda... chorando aqui 😢 Ficou lindo demais!! Amei, amei, amei. Parabéns pelo trabalho, vocês arrasaram!", role: "Presente de aniversário" },
    { name: "Karina F.", city: "São Paulo - SP", context: "Encomendou uma música para o aniversário do marido", quote: "Dei de presente no aniversário dele, e ele chorou do início ao fim. Foi inesquecível ...", role: "Presente de aniversário" },
    { name: "Eduardo T.", city: "Curitiba - PR", context: "Encomendou uma música de homenagem romântica", quote: "A música contou exatamente a nossa história. Gostei do atendimento — parece que cada detalhe foi pensado com carinho.", role: "Homenagem romântica" },
  ];

  const faqs = [
    { q: "O que é uma música personalizada?", a: "É uma canção inédita criada especialmente para uma pessoa específica — com letra que cita o nome dela, suas memórias e história. Na Música Surpresa, a composição e a gravação são feitas do zero a partir das informações que você nos fornece." },
    { q: "Qual o prazo de entrega?", a: "As músicas são entregues em até 24 horas. Entre em contato com a gente se tiver urgência." },
    { q: "Como funciona o pagamento?", a: "O pagamento é totalmente online, e a produção da música é iniciada logo após aprovação / confirmação do pagamento." },
    { q: "Vocês atendem empresas?", a: "Sim. Também criamos músicas personalizadas para eventos, ações corporativas, homenagens e campanhas especiais." },
    { q: "A letra vai ter o nome da pessoa?", a: "Sim! A letra é criada com o nome dela, memórias que vocês compartilham, frases carinhosas e tudo que você nos contar. É uma música que só existe para ela." },
  ];

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (!element) return;
    const offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
  };

  return (
    <div id="topo" className="min-h-screen" style={{ backgroundColor: BRAND.warmBg, color: BRAND.text }}>

      <Header logoMusicaSurpresa={logoMusicaSurpresa} />

      {/* Hero */}
      <section className="relative overflow-hidden" style={{ backgroundColor: BRAND.cream }}>
        <div className="mx-auto grid max-w-7xl items-start gap-5 px-4 py-5 lg:grid-cols-2 lg:gap-8 lg:px-10 lg:py-8">
          <div className="flex flex-col justify-start pt-1 lg:min-h-[400px] lg:pt-6">
            <div className="mx-auto max-w-[340px] text-center sm:max-w-[520px] lg:mx-0 lg:max-w-2xl lg:text-left">
              <h1 className="mx-auto max-w-[340px] text-[31px] font-black leading-[1.02] tracking-[-0.04em] sm:max-w-[520px] sm:text-[36px] lg:mx-0 lg:min-h-[170px] lg:max-w-[600px] lg:text-[44px]" style={{ color: BRAND.text, opacity: 0.85 }}>
                {activeHeroSlide.title}
              </h1>
              <p className="mx-auto mt-3 max-w-[340px] text-[15px] font-medium leading-[1.55] sm:max-w-[520px] sm:text-[16px] lg:mx-0 lg:min-h-[96px] lg:max-w-[680px] lg:text-[20px]" style={{ color: BRAND.muted, opacity: 0.75 }}>
                {activeHeroSlide.description}
              </p>
              <div className="hidden mt-7 min-h-[92px] flex-wrap gap-3 text-[14px] font-semibold lg:flex lg:gap-4 lg:text-[15px]" style={{ color: BRAND.terracottaDark }}>
                {activeHeroSlide.pills.map((pill) => (
                  <span key={pill} className="flex h-[58px] w-[160px] items-center justify-center rounded-[18px] border px-3 text-center leading-tight shadow-sm lg:h-[62px] lg:w-[170px]" style={{ backgroundColor: BRAND.terracottaSoft, borderColor: "rgba(201,79,54,0.14)" }}>
                    <span className="flex flex-col items-center justify-center leading-tight">
                      {pill.split("\n").map((line, i) => <span key={i} className="block">{line}</span>)}
                    </span>
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className="flex items-start justify-end pt-0 lg:min-h-[430px] lg:pt-6">
            <div className="relative aspect-[4/3] w-full max-w-[600px] overflow-hidden rounded-[28px] shadow-[0_20px_50px_rgba(0,0,0,0.10)] lg:rounded-[34px]" style={{ backgroundColor: BRAND.terracottaSoft }}>
              <img fetchpriority="high" src={activeHeroSlide.image} alt={activeHeroSlide.imageAlt} className="h-full w-full object-contain object-center transition-opacity duration-700" />
            </div>
          </div>
        </div>

        <div className="border-t border-black/5" style={{ backgroundColor: BRAND.warmBg }}>
          <div className="mx-auto max-w-7xl px-4 py-6 lg:px-10 lg:py-8">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
              <a href="#formulario" style={{ backgroundColor: BRAND.terracotta, boxShadow: "0 14px 34px rgba(201,79,54,0.22)" }} className="order-2 inline-flex min-h-[68px] items-center justify-center rounded-[18px] px-8 text-[18px] font-black text-white transition-all duration-300 hover:scale-[1.01] hover:opacity-95 hover:shadow-xl lg:order-none lg:min-w-[400px] lg:px-10 lg:text-[20px]">
                <span aria-hidden="true">💝 </span>CRIAR MÚSICA
              </a>
              <div className="order-1 grid gap-4 lg:order-none lg:flex lg:items-center lg:gap-6">
                {[
                  { icon: "⭐", title: "100% Personalizada", sub: "com nomes e frases" },
                  { icon: "⚡", title: "Entrega Rápida", sub: "em menos de 24h" },
                  { icon: "💝", title: "Presente Inesquecível", sub: "que emociona de verdade" },
                ].map((item) => (
                  <div key={item.title} className="flex items-center gap-4">
                    <div className="flex h-14 w-14 items-center justify-center rounded-full text-[26px]" style={{ backgroundColor: BRAND.terracottaSoft, color: BRAND.terracottaDark }}>
                      {item.icon}
                    </div>
                    <div>
                      <p className="text-[18px] font-black leading-none lg:text-[20px]" style={{ color: BRAND.navy }}>{item.title}</p>
                      <p className="mt-2 text-[15px] leading-none lg:text-[16px]" style={{ color: BRAND.muted }}>{item.sub}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* O que é */}
      <section id="o-que-e" className="scroll-mt-24 py-10 lg:py-14" style={{ backgroundColor: BRAND.cream }}>
        <div className="mx-auto max-w-7xl px-4 lg:px-10">
          <div className="text-center mb-10">
            <p className="text-sm font-bold uppercase tracking-[0.2em]" style={{ color: BRAND.terracotta }}>
              Entenda o produto
            </p>
            <h2 className="mt-3 text-2xl font-black tracking-[-0.03em] sm:text-3xl lg:text-4xl" style={{ color: BRAND.navy }}>
              O que é a Música Surpresa?
            </h2>
          </div>

          {/* 3 cards sequenciais */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:gap-6 max-w-5xl mx-auto">
            {[
              {
                icon: "💬",
                title: "Você conta pra gente",
                text: "Quem é a pessoa, o que ela significa para você, a ocasião e o que quer expressar",
                step: "1",
              },
              {
                icon: "🎵",
                title: "A gente produz a música",
                text: "Produzimos a letra e a melodia com base em tudo que você nos contou",
                step: "2",
              },
              {
                icon: "🎁",
                title: "Você recebe o áudio",
                text: "Uma música inédita em MP3 — com o nome, as frases, a história da pessoa — pronta para emocionar",
                step: "3",
              },
            ].map((card, index, arr) => (
              <div key={card.step} className="relative flex flex-col items-center text-center rounded-[24px] border border-[#E8DDD2] bg-white px-6 py-8 shadow-sm">
                {/* seta entre cards — só aparece entre eles, não após o último */}
                {index < arr.length - 1 && (
                  <div className="hidden sm:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 h-8 w-8 items-center justify-center rounded-full text-lg font-black" style={{ backgroundColor: BRAND.terracottaSoft, color: BRAND.terracotta }}>
                    →
                  </div>
                )}
                <div className="flex h-16 w-16 items-center justify-center rounded-full text-3xl mb-4" style={{ backgroundColor: BRAND.terracottaSoft }}>
                  {card.icon}
                </div>
                <span className="text-xs font-bold uppercase tracking-[0.18em] mb-2" style={{ color: BRAND.terracotta }}>
                  Passo {card.step}
                </span>
                <h3 className="text-lg font-black mb-3" style={{ color: BRAND.navy }}>
                  {card.title}
                </h3>
                <p className="text-sm leading-7" style={{ color: BRAND.muted }}>
                  {card.text}
                </p>
              </div>
            ))}
          </div>

          {/* Selos na base */}
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            {[
              "✓ Letra sobre a pessoa real",
              "✓ Melodia criada do zero",
              "✓ Entrega em até 24h",
              "✓ Com os detalhes dela — de verdade",
            ].map((selo) => (
              <span key={selo} className="rounded-full border border-[#E8DDD2] bg-white px-5 py-2 text-sm font-semibold" style={{ color: BRAND.terracottaDark }}>
                {selo}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Como Funciona */}
      <section id="como-funciona" className="scroll-mt-30 pb-4 pt-0 lg:scroll-mt-20 lg:pb-10 lg:pt-4" style={{ backgroundColor: BRAND.warmBg }}>
        <div className="mx-auto max-w-7xl px-4 lg:px-10">
          <div className="text-center">
            <h2 className="mt-3 text-2xl font-black leading-tight tracking-[-0.03em] sm:text-3xl lg:mt-8 lg:text-4xl" style={{ color: BRAND.navy }}>
              Veja como funciona, passo a passo
            </h2>
          </div>
          <div className="mt-8 grid gap-5 md:grid-cols-2 lg:mt-12 lg:grid-cols-4 lg:gap-8">
            {steps.map((step, index) => (
              <div key={step.title} className="rounded-[24px] border border-[#E8DDD2] bg-white/55 px-5 py-6 text-center shadow-sm lg:border-0 lg:bg-transparent lg:px-0 lg:py-0 lg:shadow-none">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl text-2xl shadow-[0_10px_24px_rgba(178,79,54,0.14)] ring-1 ring-[#F3D6C8] lg:h-20 lg:w-20 lg:rounded-full lg:text-3xl" style={{ backgroundColor: "#FFF1EA", color: step.color }}>
                  {step.icon}
                </div>
                <h3 className="mt-4 text-base font-black leading-tight lg:mt-7 lg:text-lg" style={{ color: BRAND.navy }}>{index + 1}. {step.title}</h3>
                <p className="mt-2 text-sm leading-6 lg:mt-3 lg:leading-7" style={{ color: BRAND.muted }}>{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Player de demos */}
      <section id="musicas" aria-labelledby="titulo-musicas" className="scroll-mt-24 pb-8 pt-0 lg:scroll-mt-10 lg:pb-20 lg:pt-6" style={{ backgroundColor: BRAND.warmBg }}>
        <div className="mx-auto max-w-7xl px-4 lg:px-9">
          <div className="text-center">
            <h2 id="titulo-musicas" className="mt-0 text-2xl font-black leading-tight tracking-[-0.03em] sm:text-3xl lg:text-4xl" style={{ color: BRAND.navy }}>✨Músicas criadas para emocionar✨</h2>
            <p className="mx-auto mt-3 max-w-4xl text-[15px] leading-7 text-[#4B5563] lg:mt-4 lg:text-base">
              Ouça músicas criadas por nós e comprove a qualidade, emoção e cuidado com cada pedido
            </p>
          </div>
          <div className="mx-auto mt-8 max-w-7xl rounded-[28px] border p-3 shadow-sm lg:mt-10 lg:p-7" style={{ backgroundColor: BRAND.cream, borderColor: BRAND.terracottaSoft }}>
            <audio ref={audioRef} preload="none" onEnded={() => setIsPlaying(false)} />
            <div className="mb-3 text-[11px] font-bold tracking-[0.14em] text-[#B24F36] lg:hidden text-center">
              Ouça algumas de nossas músicas
            </div>
            <div className="grid grid-cols-2 gap-3 px-1 pb-3 lg:grid-cols-5 lg:gap-4 lg:px-0 lg:pb-2">
              {visibleDemoSongs.map((song) => {
                const isActive = song.songIndex === currentSongIndex;
                return (
                  <button key={`${song.title}-${song.songIndex}`} type="button" onClick={() => handleSelectSong(song.songIndex)}
                    aria-label={`${isActive && isPlaying ? "Pausar" : "Ouvir"} a música ${song.title} — ${song.occasion}`}
                    aria-pressed={isActive}
                    className={`flex min-h-[166px] flex-col justify-between rounded-[20px] border p-4 text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-md lg:min-h-[178px] lg:rounded-[22px] lg:p-5 ${isActive ? "shadow-lg lg:scale-[1.03]" : "shadow-sm"}`}
                    style={{ backgroundColor: isActive ? "#FFF1EA" : "#FFFFFF", borderColor: isActive ? BRAND.terracotta : BRAND.terracottaSoft, transformOrigin: "center" }}>
                    <div>
                      <h3 className="mt-4 text-base font-black leading-tight tracking-[-0.03em] lg:mt-5 lg:text-xl" style={{ color: BRAND.navy }}>{song.title}</h3>
                      <p className="mt-2 text-xs font-semibold leading-5 lg:mt-3 lg:text-sm lg:leading-6" style={{ color: BRAND.muted }}>{song.occasion}</p>
                    </div>
                    <div className="mt-4 flex items-end justify-between gap-2 border-t pt-3 lg:mt-5 lg:gap-3 lg:pt-4" style={{ borderColor: BRAND.terracottaSoft }}>
                      <div>
                        <span className="block text-[11px] font-bold leading-4 lg:text-xs lg:leading-5" style={{ color: BRAND.terracotta }}>{song.style}</span>
                        <span className="mt-1 block text-[9px] font-semibold tracking-[0.04em]" style={{ color: isActive ? BRAND.terracotta : BRAND.muted }}>{isActive ? "Tocando" : "Ouvir"}</span>
                      </div>
                      <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-black text-white transition-all duration-300 lg:h-10 lg:w-10 lg:text-sm" style={{ backgroundColor: isActive ? BRAND.terracotta : "#9CA3AF" }}>
                        {isActive && isPlaying ? "Ⅱ" : "▶"}
                      </span>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section id="depoimentos" aria-labelledby="titulo-depoimentos" className="scroll-mt-24 py-12 lg:scroll-mt-14 lg:py-20" style={{ backgroundColor: BRAND.terracotta }}>
        <div className="mx-auto max-w-7xl px-4 lg:px-10">
          <div className="text-center">
            <p className="text-sm font-bold uppercase tracking-[0.2em]" style={{ color: BRAND.terracottaSoft }}>Depoimentos</p>
            <h2 id="titulo-depoimentos" className="mt-2 text-2xl font-black leading-tight tracking-[-0.03em] text-white sm:text-3xl lg:mt-3 lg:text-4xl">
              Histórias reais, <span style={{ color: BRAND.terracottaSoft }}>emoções verdadeiras</span>
            </h2>
          </div>
          <div className="mt-8 grid gap-5 lg:mt-12 lg:grid-cols-3 lg:gap-6">
            {testimonials.map((item) => (
              <div key={item.name} className="rounded-[22px] bg-white px-6 py-5 shadow-lg lg:p-6">
                <p className="mb-3 text-xs font-semibold italic" style={{ color: BRAND.terracotta }}>{item.context}</p>
                <p className="text-sm leading-6 text-[#374151] lg:text-base lg:leading-8">"{item.quote}"</p>
                <div className="mt-4 border-t border-black/5 pt-3">
                  <p className="text-[15px] font-bold text-[#0B2454]">{item.name}</p>
                  <p className="text-xs text-[#6B7280]">{item.city}</p>
                  <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.16em]" style={{ color: BRAND.terracotta }}>{item.role}</p>
                  <p className="mt-2 text-sm" style={{ color: BRAND.terracotta }}>★★★★★</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Planos */}
      <section id="planos" aria-labelledby="titulo-como-funciona" className="scroll-mt-24 pt-8 pb-8 lg:scroll-mt-24 lg:pt-12" style={{ backgroundColor: BRAND.warmBg }}>
        <div className="mx-auto max-w-7xl px-3 lg:px-10">
          <div className="text-center">
            <h2 id="titulo-como-funciona" className="mt-1 text-2xl font-black tracking-[-0.03em] sm:text-3xl lg:text-4xl" style={{ color: BRAND.navy }}>
              ✨ Quanto custa e o que está incluído ✨
            </h2>
          </div>
          <div className="mt-10 w-full">
            {plans.map((plan) => (
              <div key={plan.name} className="relative flex flex-col gap-2 rounded-[20px] border px-2 py-3 lg:flex-row lg:items-center lg:justify-between" style={{ backgroundColor: plan.bg, borderColor: plan.border }}>
                <div className="flex items-center gap-4 pl-4 lg:w-[290px] lg:flex-shrink-0 lg:pl-6">
                  <div className="flex h-20 w-20 items-center justify-center rounded-full text-5xl text-white" style={{ backgroundColor: plan.color }}>{plan.icon}</div>
                  <h3 className="text-4xl font-black leading-[0.9] tracking-[-0.04em] lg:text-[36px]" style={{ color: plan.color }}>
                    {plan.name.split(" ")[0]}<br />{plan.name.split(" ").slice(1).join(" ")}
                  </h3>
                </div>
                <div className="lg:min-w-0 lg:flex-1 lg:pr-8">
                  <p className="text-sm leading-7" style={{ color: BRAND.muted }}>{plan.subtitle}</p>
                  <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-4 text-sm font-medium text-[#374151] lg:grid-cols-3">
                    {plan.features.map((item) => (
                      <li key={item} className="flex items-start gap-2">
                        <span style={{ color: plan.color }}>✓</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-4 hidden text-sm font-semibold leading-6 text-[#6B7280] lg:block">
                    🔒 Pagamento 100% seguro • Parcele em até 12x • Satisfação garantida
                  </div>
                </div>
                <div className="flex flex-col items-center gap-3 pr-0 text-center lg:w-[220px] lg:flex-shrink-0 lg:items-end lg:pr-6 lg:text-right">
                  <div className="mt-4 text-center lg:text-right">
                    {plan.priceFrom && (
                      <p className="text-sm font-semibold text-[#9CA3AF] line-through">{plan.priceFrom}</p>
                    )}
                    <p className="text-4xl font-black tracking-[0.03em] whitespace-nowrap" style={{ color: plan.color }}>{plan.price}</p>
                  </div>
                  <a href="#formulario" onClick={(e) => { e.preventDefault(); const selectedPlan = formatPlanLabel(DEFAULT_PLAN); sessionStorage.setItem("selectedPlan", selectedPlan); setFormData((prev) => ({ ...prev, plan: selectedPlan })); setTimeout(() => scrollTo("formulario"), 0); }} className="mt-2 flex w-full min-w-[200px] items-center justify-center rounded-xl px-3 py-3 text-sm font-bold text-white shadow-sm transition-all duration-300 hover:scale-[1.01] hover:opacity-95 lg:ml-auto lg:mt-0 lg:w-auto" style={{ backgroundColor: plan.color }}>
                    <span aria-hidden="true">💝 </span>CRIAR MÚSICA
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Formulário */}
      <section id="formulario" aria-labelledby="titulo-formulario" className="scroll-mt-24 py-10 lg:py-14" style={{ backgroundColor: BRAND.warmBg }}>
        <div className="mx-auto grid max-w-7xl items-start gap-10 px-4 lg:grid-cols-[1.05fr_0.95fr] lg:px-10">
          <div className="w-full overflow-hidden rounded-[12px] shadow-[0_18px_40px_rgba(0,0,0,0.08)]">
            <img loading="lazy" src={slide11} alt="Pessoas em um momento especial" className="h-[500px] w-full object-cover object-left lg:h-[520px] lg:object-[center_35%]" />
          </div>
          <div className="flex flex-col">
            <p className="text-sm font-bold uppercase tracking-[0.2em]" style={{ color: BRAND.terracotta }}>Comece agora</p>
            <h2 id="titulo-formulario" className="mt-3 text-3xl font-black sm:text-4xl" style={{ color: BRAND.navy }}>Conte sua história e criamos sua música</h2>
            <p className="mt-4 text-base leading-7" style={{ color: BRAND.muted }}>Preencha os dados iniciais abaixo para começarmos sua música.</p>
            <div className="mt-5 hidden flex-wrap gap-3 text-sm font-semibold lg:flex" style={{ color: BRAND.terracottaDark }}>
              <span className="rounded-full px-4 py-2" style={{ backgroundColor: BRAND.terracottaSoft }}>Resposta Rápida</span>
              <span className="rounded-full px-4 py-2" style={{ backgroundColor: BRAND.terracottaSoft }}>Atendimento Humanizado</span>
              <span className="rounded-full px-4 py-2" style={{ backgroundColor: BRAND.terracottaSoft }}>100% Personalizado</span>
            </div>
            <div className="mt-8 grid gap-4 sm:grid-cols-2">
              <label htmlFor="field-name" className="sr-only">Seu nome</label>
              <input id="field-name" name="name" value={formData.name} onChange={handleFormChange} className="rounded-xl border border-[#E8DDD2] bg-white px-4 py-3 text-sm outline-none" placeholder="Seu nome" autoComplete="name" />
              <label htmlFor="field-whatsapp" className="sr-only">WhatsApp com DDD</label>
              <input id="field-whatsapp" name="whatsapp" value={formatWhatsapp(formData.whatsapp)} onChange={handleFormChange} inputMode="tel" className="rounded-xl border border-[#E8DDD2] bg-white px-4 py-3 text-sm outline-none" placeholder="WhatsApp com DDD" autoComplete="tel" />
              <label htmlFor="field-email" className="sr-only">E-mail</label>
              <input id="field-email" type="email" name="email" value={formData.email} onChange={handleFormChange} inputMode="email" className="rounded-xl border border-[#E8DDD2] bg-white px-4 py-3 text-sm outline-none sm:col-span-2" placeholder="E-mail" autoComplete="email" />
              <div className="rounded-xl border border-[#E8DDD2] bg-[#F8F5F1] px-4 py-3 text-sm font-semibold text-[#0B2454] sm:col-span-2" aria-label={`Plano selecionado: ${formData.plan}`} role="status">{formData.plan}</div>
              <input type="hidden" name="plan" value={formData.plan} />
            </div>
            <button type="button" onClick={handleContinueToMusicForm} style={{ backgroundColor: BRAND.terracotta, boxShadow: "0 10px 22px rgba(169,98,96,0.18)" }} className="mt-6 w-full rounded-xl px-5 py-4 text-sm font-bold text-white transition-all duration-300 hover:scale-[1.01] hover:opacity-95 hover:shadow-[0_14px_28px_rgba(169,98,96,0.24)]">
              <span aria-hidden="true">💝 </span>CRIAR MÚSICA
            </button>
            <p className="mt-4 text-center text-sm text-[#6B7280]">Ao continuar, você iniciará a criação da sua música 😉</p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" aria-labelledby="titulo-faq" className="scroll-mt-24 pb-16 pt-2 lg:scroll-mt-16 lg:pt-10" style={{ backgroundColor: BRAND.warmBg }}>
        <div className="mx-auto max-w-7xl px-4 lg:px-10">
          <div className="text-center">
            <p id="titulo-faq" className="text-sm font-bold uppercase tracking-[0.2em]" style={{ color: BRAND.terracotta }}>Dúvidas frequentes</p>
          </div>
          <div className="mt-10 grid gap-4 md:grid-cols-2">
            {faqs.map((faq, index) => {
              const isOpen = openFaq === index;
              return (
                <div key={faq.q} className="overflow-hidden rounded-2xl border border-[#ECE2D8] bg-white shadow-sm transition-all duration-300">
                  <button type="button" onClick={() => setOpenFaq(isOpen ? -1 : index)} aria-expanded={isOpen} aria-controls={`faq-answer-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left">
                    <h3 className="text-lg font-bold" style={{ color: BRAND.navy }}>{faq.q}</h3>
                    <span className="text-xl font-bold" aria-hidden="true" style={{ color: BRAND.terracotta }}>{isOpen ? "−" : "+"}</span>
                  </button>
                  {isOpen && (
                    <div id={`faq-answer-${index}`} role="region" aria-label={faq.q} className="border-t border-[#F1E7DD] px-5 pb-5 pt-4">
                      <p className="text-sm leading-7" style={{ color: BRAND.muted }}>{faq.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* WhatsApp flutuante */}
      <button type="button" onClick={handleQuickWhatsApp} aria-label="Atendimento WhatsApp" className="fixed bottom-4 right-4 z-50 inline-flex items-center justify-center rounded-full bg-transparent p-0 text-white shadow-none transition-all duration-300 hover:scale-[1.03] sm:gap-2.5 sm:rounded-full sm:bg-[#38B73F] sm:px-3.5 sm:py-2.5 sm:shadow-[0_12px_26px_rgba(56,183,63,0.26)] sm:hover:shadow-[0_16px_34px_rgba(56,183,63,0.34)] lg:bottom-5 lg:right-5">
        <span className="flex h-14 w-14 min-h-[56px] min-w-[56px] aspect-square shrink-0 items-center justify-center rounded-full bg-[#25D366] shadow-[0_12px_26px_rgba(37,211,102,0.34)] sm:h-11 sm:w-11 sm:min-h-[44px] sm:min-w-[44px] sm:border-[2.5px] sm:border-white sm:bg-[#38B73F] sm:shadow-sm">
          <img src={whatsappIcon} alt="WhatsApp" className="h-[74%] w-[74%] object-contain sm:h-[72%] sm:w-[72%]" />
        </span>
        <span className="hidden text-left text-[13px] font-bold leading-[1.02] tracking-[-0.02em] sm:inline">
          <span className="block">Atendimento</span>
          <span className="block">WhatsApp</span>
        </span>
      </button>

      <Footer BRAND={BRAND} logoMusicaSurpresa={logoMusicaSurpresa} />
    </div>
  );
}
